<template>
  <div class="market">
    <div class="market-l">
      <div class="l-title">
        <span class="title_name">销售管理</span>
        <div class="upload-box" @click="handleImportFile">
          <img src="@/assets/image/land/addland.png" class="add-icons" />
          文件导入
        </div>
      </div>
      <div class="my-table">
        <MyTable :tableData="tableData" :configTable="configTable" />
        <el-pagination
          v-if="tableData.length"
          background
          layout="prev, pager, next"
          :page-size="20"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="market-c">
      <ChartsFilter></ChartsFilter>
      <!-- <div class="filter-box">

      </div> -->
      <div class="tips">2017-2023年中国稻谷和稻谷进口量及增长情况</div>
      <v-chart class="v-chart" autoresize :option="mixedOption"></v-chart>
      <div class="tips">2021-2023年中国稻谷均价走势图</div>
      <v-chart class="v-chart" autoresize :option="lineOption"></v-chart>
    </div>
    <!-- 文件导入 -->
    <el-dialog
      class="big-pop small-pop"
      title=" "
      :visible.sync="fileImportShow"
      width="598px"
      :before-close="setFileImportClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="big-main">
        <div class="ware-title">
          <div class="left-line"></div>
          文件导入
        </div>
        <div class="add-form">
          <el-form ref="form" hide-required-asterisk label-position="top">
            <el-form-item label="" prop="cover">
              <el-upload
                ref="uploadFileRef"
                action="https://hs.darsing.net/project/digital2/hanshan/order/add"
                accept=".xlsx,.xls,.csv"
                :limit="1"
                :file-list="addFileList"
                :headers="uploadHeaders"
                :auto-upload="false"
                :on-exceed="handleFileExceed"
                :on-error="handleFileFail"
                :on-success="handleFileSuccess"
              >
                <el-button slot="trigger" type="primary">选取文件</el-button>
                <el-button style="margin-left: 20px" type="success" @click="submitUpload">文件导入</el-button>
                <div slot="tip" class="el-upload__tip">只能上传Excel/CSV文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <MyNav ref="MyNav" />
  </div>
</template>

<script>
import * as echarts from 'echarts/core'
import { TooltipComponent, GridComponent, LegendComponent } from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { BarChart, LineChart } from 'echarts/charts'
import { UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([TooltipComponent, GridComponent, LegendComponent, BarChart, LineChart, CanvasRenderer, UniversalTransition])
import { getMarketOrderListApi, getOrderStatisticsApi } from '@/request/api.js'
export default {
  provide: {
    [THEME_KEY]: 'dark'
  },
  components: {
    VChart,
    MyTable: () => import('@/components/MyTable.vue'),
    MyNav: () => import('@/components/MyNav.vue'),
    ChartsFilter: () => import('@/components/ChartsFilter.vue')
  },
  data() {
    return {
      addFileList: [],
      fileImportShow: false,
      uploadHeaders: {
        Authorization: localStorage.getItem('darsingToken')
      },
      lineOption: {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['2021年', '2022年', '2023年']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
          type: 'value',
          name: '元/吨'
        },
        series: [
          {
            name: '2021年',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210, 120, 242, 234, 412, 356]
          },
          {
            name: '2022年',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310, 380, 202, 294, 382, 306]
          },
          {
            name: '2023年',
            type: 'line',
            stack: 'Total',
            data: [150, 232, 201, 154, 190, 330, 410, 220, 342, 234, 512, 456]
          }
        ]
      },
      mixedOption: {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },

        legend: {
          data: ['进口数量(万吨)', '数量增长率(%)']
        },
        xAxis: [
          {
            type: 'category',
            data: ['2017年', '2018年', '2019年', '2020年', '2021年', '2022年', '2023年'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '进口数量(万吨)',
            min: 0,
            max: 250,
            interval: 50
          },
          {
            type: 'value',
            name: '数量增长率(%)',
            min: 0,
            max: 25,
            interval: 5
          }
        ],
        series: [
          {
            name: '进口数量(万吨)',
            type: 'bar',

            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
          },

          {
            name: '数量增长率(%)',
            type: 'line',
            yAxisIndex: 1,

            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
          }
        ]
      },
      total: 20,
      current_page: 1,
      tableData: [],
      configTable: [
        {
          prop: 'date',
          label: '时间',
          width: ''
        },
        {
          prop: 'c_name',
          label: '品类',
          width: '120'
        },
        {
          prop: 'name',
          label: '名称',
          width: ''
        },
        {
          prop: 'area',
          label: '地区',
          width: ''
        },
        {
          prop: 'cycle',
          label: '周期',
          width: '80'
        },
        {
          prop: 'uint',
          label: '单位',
          width: '120'
        },
        {
          prop: 'num',
          label: '数值',
          width: ''
        }
      ],
      statList: [],
      isBoxShowNum: 14
    }
  },
  created() {
    this.getList()
    this.getOrderStatistics()
  },
  methods: {
    submitUpload() {
      this.$refs.uploadFileRef.submit()
    },
    async getOrderStatistics() {
      const { code, results } = await getOrderStatisticsApi({
        // manor_id: +this.farmID,
        // mid: this.mid,
        // date: this.date,
        // cid: this.tabIndex,
        // pn: this.pn
      })
      if (code != 0) return
      this.mixedOption.xAxis[0].data = results.categories
      this.mixedOption.series[0].data = results.series[0]
      this.mixedOption.series[1].data = results.series[1]
    },
    async getList() {
      const { code, results } = await getMarketOrderListApi({
        pn: this.pn
      })
      if (code != 0) return
      this.tableData = results.data
      this.total = results.count
      this.pn = results.pn
      this.ps = results.ps
    },
    setFileImportClose() {
      this.fileImportShow = false
      this.addFileList = []
    },
    handleFileExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleFileFail() {
      this.$notify.error({
        title: '错误',
        message: '上传失败，稍后尝试'
      })
    },
    handleFileSuccess(res, file) {
      if (file.percentage === 100) {
        this.getList()
        this.addFileList = []

        this.fileImportShow = false
        this.$notify({
          title: '成功',
          message: '文件已导入',
          type: 'success'
        })
      }
    },
    handleImportFile() {
      this.fileImportShow = true
    },
    // 切换分页
    handleCurrentChange(val) {
      this.pn = val
      this.getList()
    },
    lookApp() {
      this.isBoxShowNum = 13
    }
  }
}
</script>

<style lang="less" scoped>
.market {
  width: 100%;
  height: 100vh;
  background: #071a2c;

  padding: 76px 0 0;
  display: flex;
  justify-content: space-between;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0;
  }
  .tips {
    width: 100%;
    height: 33px;
    line-height: 33px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 28px;
  }
  .market-l {
    width: 60%;
    height: 100%;
    background: #142d4c;
    padding: 30px 58px;
    .l-title {
      width: 100%;
      position: relative;
      padding: 0 0 0 11px;
      margin-bottom: 27px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 4px;
        height: 22px;
        background: #3e90e5;
        border-radius: 2px;
      }
      .title_name {
        font-size: 22px;
        font-weight: 400;
        color: #fff;
      }
      .upload-box {
        width: 143px;
        height: 40px;
        background-color: #3e90e5;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        float: right;
        margin-left: 10px;
        &:hover {
          opacity: 0.8;
        }
        .add-icons {
          width: 18px;
          height: 18px;
          margin-right: 13px;
        }
      }
    }
    .my-table {
      width: 100%;
      min-height: 690px;
    }
  }
  .market-c {
    height: 100%;
    width: 38%;
    background: #0e2138;
    margin: 0 16px;
    padding: 30px 30px;
    .v-chart {
      width: 100%;
      height: 35%;
    }
  }

  .big-pop {
    /deep/.el-dialog {
      width: 598px !important;
      background-color: inherit;
    }

    /deep/.el-dialog__body {
      padding: 0;
    }

    /deep/.el-dialog__headerbtn {
      font-size: 26px;
      top: 64px;
      right: 50px;
      font-weight: bold;
    }
  }

  .big-pop {
    /deep/.el-form-item {
      margin-bottom: 32px;
    }

    /deep/.el-button span {
      color: #fff;
    }

    /deep/.el-dialog__headerbtn {
      top: 71px;
      right: 44px;
    }

    /deep/.dialog-footer {
      margin-top: 40px;
      padding: 0 0 0 119px;
    }

    .ok-button {
      width: 150px;
      height: 40px;
      margin-right: 44px;
    }

    .no-button {
      width: 150px;
      height: 40px;
      border: 1px solid #385576;
      background-color: #0f243d;
    }

    .big-main {
      width: 598px;
      height: 539px;
      background: url(../assets/image/configure/process/addbgimg.png) no-repeat center center;
      background-size: cover;
      padding: 45px 55px;
      overflow: hidden;
      .ware-title {
        font-size: 22px;
        color: #fff;
        font-weight: bold;
        display: flex;
        margin-bottom: 40px;
        align-items: center;
        .left-line {
          background-color: #fff;
          width: 4px;
          height: 21px;
          border-radius: 3px;
          margin-right: 10px;
        }
      }

      .block {
        width: 100%;
        height: calc(100% - 124px);
        overflow: auto;
        padding: 0 2px;

        &::-webkit-scrollbar {
          width: 1px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #ccc;
        }
      }
      /deep/.uploadCover {
        width: 158px;
        height: 105px;
        display: flex;
        .el-upload--picture-card {
          width: 100%;
          height: 100%;
          line-height: 105px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
          width: 158px;
          height: 105px;
        }
        &.active {
          .el-upload--picture-card {
            display: none;
          }
        }
      }
      /deep/.el-card {
        background-color: #081c30;
        border: none;
      }

      /deep/.el-timeline-item__tail {
        border-left: 2px solid #385576;
      }

      /deep/.el-timeline-item__timestamp {
        font-size: 18px;
        color: #fff;
      }

      /deep/.el-card__body {
        width: 450px;
        min-height: 83px;
        padding: 18px 15px;
      }

      /deep/.el-timeline-item__node {
        background-color: #67c23a;
      }

      /deep/.el-timeline-item.active {
        .el-timeline-item__node {
          background-color: #e60000;
        }
      }

      .info-col1 {
        margin-bottom: 16px;

        span {
          font-size: 18px;
          color: #fff;
          margin-right: 16px;
        }

        .num {
          color: #e60000;
        }

        .num.active {
          color: #67c23a;
        }
      }

      .info-col2 {
        span {
          font-size: 14px;
        }

        .text1 {
          color: #57708d;
          margin-right: 14px;
        }

        .text2 {
          color: #fff;
          margin-right: 20px;
        }

        .text3 {
          color: #57708d;
          margin-right: 10px;
        }

        .text4 {
          color: #3e90e5;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      /deep/.el-input__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
      }

      /deep/.el-textarea__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
        height: 120px;
        resize: none;
      }

      /deep/.el-form-item__label {
        font-size: 14px;
        color: #fff;
        padding: 0 24px 0 0;
      }

      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #fff;
      }

      /deep/.el-radio {
        color: #fff;
      }
      .add-form {
        width: 100%;
        height: calc(100% - 56px);
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #3e90e5;
        }
      }
    }
  }
  // .big-pop.small-pop {
  //   .big-main {
  //     width: 598px;
  //     height: 539px;
  //     background: url(../assets/image/configure/process/addbgimg.png) no-repeat center center;
  //   }
  // }
}
</style>
